module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/WizardButton/images/border-selected.13870e23.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/WizardButton/images/border-selected.png
// module id = 2539
// module chunks = 11